export enum AwsHeaders {
  CONTENT_SHA256 = 'x-amz-content-sha256',
  TARGET = 'x-amz-target',
  DATE = 'x-amz-date',
  SECURITY_TOKEN = 'x-amz-security-token',
  AUTHORIZATION = 'authorization',
  HOST = 'host',
  CONTENT_TYPE = 'content-type'
}
